export const actions = {
  STORE_ROOM_DETAILS: 'STORE_ROOM_DETAILS',
  CALL_ENDED: 'CALL_ENDED',
  CALL_FAILED: 'CALL_FAILED',
  START_VIDEO: 'START_VIDEO',
  STORE_CALL_CHANNEL: 'STORE_CALL_CHANNEL',
};


const initVideo = {
  callInProgress: false,
  room: {},
  channel: {}
};

export default (state = initVideo, action) => {
  switch (action.type) {
    case actions.STORE_ROOM_DETAILS :
      return {
        ...state,
        ...action.payload,
        callInProgress: true,
      };
    case actions.CALL_ENDED:
      return {
        ...state,
        callInProgress: false,
        room: {},
        error: null
      };
    case actions.CALL_FAILED:
      return {
        ...state,
        callInProgress: false,
        room: {},
        error: action.payload
      };
    case actions.START_VIDEO:
      return {
        ...state,
        callInProgress: true,
        channel: action.payload,
        error: null
      };
    case actions.STORE_CALL_CHANNEL:
      return {
        ...state,
        channel: action.payload,
      };
    default:
      return state
  }
}


